import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const promoQuotaAllTariffsLink = getFeature('all-tariff-link'); // 'https://help.mail.ru/cloud_web/size/tariff/'
